import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { DatabaseHero } from '../components/local-business-database/DatabaseHero';
import { DatabaseDataPreview } from '../components/local-business-database/DatabaseDataPreview';
import { DatabaseWorkflow } from '../components/local-business-database/DatabaseWorkflow';
import { DatabaseFields } from '../components/local-business-database/DatabaseFields';
import { DatabaseIndustryGrid } from '../components/local-business-database/DatabaseIndustryGrid';
import { DatabaseDemo } from '../components/local-business-database/DatabaseDemo';
import { DatabaseComparison } from '../components/local-business-database/DatabaseComparison';
import { DatabaseCityLinks } from '../components/local-business-database/DatabaseCityLinks';
import { DatabaseUseCases } from '../components/local-business-database/DatabaseUseCases';
import { DatabaseFAQ } from '../components/local-business-database/DatabaseFAQ';
import { DatabaseCta } from '../components/local-business-database/DatabaseCta';
import { DatabaseIcon } from 'lucide-react';
const databaseFeatures = [{
  title: 'Plumbing contacts database',
  description: 'Access plumbing contractors with verified contact info.',
  href: 'https://openmart.com/data/plumbing',
  cta: 'Explore plumbers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Restaurant contacts database',
  description: 'Find restaurants with reviews and contact details.',
  href: 'https://openmart.com/data/restaurants',
  cta: 'Explore restaurants',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Property management contacts database',
  description: 'Discover property managers with verified details.',
  href: 'https://openmart.com/data/property-management',
  cta: 'Explore property managers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Doctor contacts database',
  description: 'Access medical practices and physicians.',
  href: 'https://openmart.com/data/doctors',
  cta: 'Explore doctors',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Dentist contacts database',
  description: 'Find dental practices with contact information.',
  href: 'https://openmart.com/data/dentists',
  cta: 'Explore dentists',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Car dealer contacts database',
  description: 'Discover car dealerships with location details.',
  href: 'https://www.openmart.com/data/car-dealer',
  cta: 'Explore car dealers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}];
export function LocalBusinessDatabase() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-4400">
      <Navbar data-id="element-4401" />
      <main data-id="element-4402">
        <DatabaseHero data-id="element-4403" />
        <TrustBar data-id="element-4404" />
        <DatabaseDataPreview data-id="element-4405" />
        <DatabaseWorkflow data-id="element-4406" />
        <DatabaseFields data-id="element-4407" />
        <DatabaseIndustryGrid data-id="element-4408" />
        <DatabaseDemo data-id="element-4409" />
        <DatabaseComparison data-id="element-4410" />
        <DatabaseCityLinks data-id="element-4411" />
        <DatabaseUseCases data-id="element-4412" />
        <DatabaseFAQ data-id="element-4413" />
        <RelatedFeatures features={databaseFeatures} data-id="element-4414" />
        <DatabaseCta data-id="element-4415" />
      </main>
      <Footer data-id="element-4416" />
    </div>;
}